import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";

export const useMinMaxGrowingSeason = (growingSeasonYear: number) => {
  const [minGrowingSeason, setMinGrowingSeason] = useState<Dayjs>(dayjs(`${growingSeasonYear}-02-20`));
  const [maxGrowingSeason, setMaxGrowingSeason] = useState<Dayjs>(dayjs(`${growingSeasonYear}-02-20`).add(1, "year"));
  useEffect(() => {
    setMinGrowingSeason(dayjs(`${growingSeasonYear}-02-20`));
    setMaxGrowingSeason(dayjs(`${growingSeasonYear}-02-20`).add(1, "year"));
  }, [growingSeasonYear]);
  return [minGrowingSeason, maxGrowingSeason];
};

export const useMinMaxSpring = (growingSeasonYear: number) => {
  const [minSpring, setMinSpring] = useState<Dayjs>(dayjs(`${growingSeasonYear}-02-20`));
  const [maxSpring, setMaxSpring] = useState<Dayjs>(dayjs(`${growingSeasonYear}-08-21`));
  useEffect(() => {
    setMinSpring(dayjs(`${growingSeasonYear}-02-20`));
    setMaxSpring(dayjs(`${growingSeasonYear}-08-21`))
  }, [growingSeasonYear]);
  return [minSpring, maxSpring];
};

export const useMinMaxAutumn = (growingSeasonYear: number) => {
  const [minAutumn, setMinAutumn] = useState<Dayjs>(dayjs(`${growingSeasonYear}-08-22`));
  const [maxAutumn, setMaxAutumn] = useState<Dayjs>(dayjs(`${growingSeasonYear}-02-19`).add(1, "year"));
  useEffect(() => {    
    setMinAutumn(dayjs(`${growingSeasonYear}-08-22`));
    setMaxAutumn(dayjs(`${growingSeasonYear}-02-19`).add(1, "year"));
  }, [growingSeasonYear]);
  return [minAutumn, maxAutumn];
};